export var setLocalStorageItem = function setLocalStorageItem(key, value) {
  window.localStorage.setItem(key, value);
};
export var getLocalStorageItem = function getLocalStorageItem(key) {
  return window.localStorage.getItem(key);
};